export const CONFIRM_AUTHORIZATION_REQUEST = "CONFIRM_AUTHORIZATION_REQUEST";
export const CONFIRM_AUTHORIZATION_SUCCESS = "CONFIRM_AUTHORIZATION_SUCCESS";
export const CONFIRM_AUTHORIZATION_FAILURE = "CONFIRM_AUTHORIZATION_FAILURE";

export const CANCEL_AUTHORIZATION_REQUEST = "CANCEL_AUTHORIZATION_REQUEST";
export const CANCEL_AUTHORIZATION_SUCCESS = "CANCEL_AUTHORIZATION_SUCCESS";
export const CANCEL_AUTHORIZATION_FAILURE = "CANCEL_AUTHORIZATION_FAILURE";
